import React from 'react'
import { atTextDirection } from '@fs/zion-ui'
import { Usabilla } from '@fs/zion-usabilla'
import usabillaConfig from './usabilla-config'

export default function FeedbackButton(): JSX.Element {
  // Usabilla uses a physical side. Mirror it for right-to-left languages.
  const side = atTextDirection({ ltr: 'right', rtl: 'left' } as const)
  return <Usabilla {...usabillaConfig} hideOnMobile side={side} />
}
